import { useCallback, useState } from 'react';

import { useApiClient } from '@/helpers/ApiClients';

const useEditServiceLevel = () => {
  const [loading, setLoading] = useState(false);
  const device = useApiClient('deviceV3');

  const editServiceLevel = useCallback(
    (body: any) => {
      setLoading(true);
      const { id, ...rest } = body;

      return device.put(`/service_levels/${id}`, rest).then(() => {
        setLoading(false);
      });
    },
    [device]
  );

  return { loading, editServiceLevel, setLoading };
};

export default useEditServiceLevel;
